import React, { useEffect, useState } from "react";
import { icons } from "../../assets/icons";
import { assetGifCharacter } from "../../assets/charactergifs";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";


const selectCharacter = localStorage.getItem("character") ?? "1"
const namesCharactes = {
	"1": "andatti",
	"2": "cel",
	"3": "premia",
	"4": "spin",
}

export const ModalResultFinalTeam = ({
	title = "",
	subTitle = "",
	buttonText = "",
	actionButton = () => { },
	actionBack = () => { },
}) => {
	const [imgStatus, setImgStatus] = useState("")
	useEffect(() => {
		const name = namesCharactes[selectCharacter]
		if (!name) {
			return
		}
		const { festejo } = assetGifCharacter[name]
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardFine)
		setImgStatus(festejo)
	}, [])
	return (
		<div className="fixed z-30 bg-[#00000074] w-full h-full flex justify-center items-center">
			<div
				className={`w-[272px] h-[312px] md:w-[464px] md:h-[552px] border-white overflow-hidden border-[4px] bg-cover bg-no-repeat bg-center rounded-3xl relative bg-backfeedbackParty`}
			>
				<div className="absolute pt-4 pb-5 md:pt-4 md:pb-10 z-20 h-full w-full">
					<div className="h-full w-full">
						<div className=" h-[24px] md:h-[44px] flex items-center px-4 md:px-6">
							<div className="w-[44px] h-[24px] md:h-[40px] md:w-[80px]">
								<img className="h-full w-full object-contain" src={icons.logooxxo} alt="logo" />
							</div>
						</div>
						<div className="h-[32px] md:h-[64px] flex justify-center items-center">
							<p className="text-white text-[20px] md:text-[40px] font-bold text-center">{title}</p>
						</div>
						<div className="h-[calc(100%-116px)] md:h-[calc(100%-188px)] px-12 md:px-24 ">
							<div className="relative h-full w-full">
								<div className="absolute z-10 h-full md:h-[110%] w-full -top-3 md:-top-7">
									<div className="h-full w-full flex justify-center items-center">
										{/* <img className="h-full w-full object-contain" src={imgs.personGame} alt="game" /> */}
										<img className="h-full w-full object-contain" src={imgStatus} alt="game" />
									</div>
								</div>
								<div className="absolute z-20 bottom-0 w-full h-[40px] md:h-[72px] flex justify-center items-center px-2">
									<p className="text-white text-[12px] md:text-[20px] text-center font-bold">{subTitle}</p>
								</div>
							</div>
						</div>
						<div className="h-[60px] md:h-[80px]">
							<div className="h-full w-full px-14 md:px-24 flex justify-center items-center flex-col gap-1">
								{buttonText && (
									<div onClick={() => {
										ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
										actionButton()
									}} className="boxShadowButtons bg-yellow_primary h-full w-full rounded-[8px] flex justify-center items-center">
										<p className="text-white text-[11px] md:text-[16px] font-semibold">{buttonText}</p>
									</div>
								)}
								<div onClick={() => {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
									actionBack()
								}} className="boxShadowButtons border-[2px] border-white h-full w-full rounded-[8px] flex justify-center items-center max-h-8 md:max-h-10">
									<p className="text-white text-[11px] md:text-[16px] font-semibold">Regresar a Home</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
